import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

const loader = lazyForPaint(() => import(/* webpackChunkName: 'view-topic' */ './topic'));
export const ViewTopic = withAsync({
    loader,
});
